/**
 * Explicit access-denied screen for a guarded route the signed-in account
 * cannot use. Rendered in place, not a silent redirect back to the overview,
 * so the account learns what was blocked rather than just landing somewhere
 * else unexplained.
 *
 * @module router/AccessDeniedRoute
 */

import { useLocation } from "react-router";

import { EmptyState, LinkButton } from "@/components/ui";

interface AccessDeniedLocationState {
  from?: string;
}

export function AccessDeniedRoute() {
  const location = useLocation();
  const state = location.state as AccessDeniedLocationState | null;
  return (
    <EmptyState
      icon="lock-key"
      headingLevel={1}
      title="Access denied"
      description={
        <>
          This account does not have permission to view{" "}
          {state?.from ? <code>{state.from}</code> : "this page"}.
        </>
      }
      action={
        <LinkButton to="/" variant="primary" icon="house">
          Back to overview
        </LinkButton>
      }
    />
  );
}
